<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
  <div mat-dialog-content>
    <div class="flex flex-row gap-4">
      @if (!data?.confirm) {
        <span class="text-3xl text-red-500"><mat-icon inline>warning</mat-icon></span>
      }
      <p [innerHTML]="data.text"></p>
    </div>
    @if (data?.counties?.length) {
      <div>
        @for (state of data?.counties; track state) {
          <p class="state-name-position font-bold">{{ state.state_name }}</p>
          <div>
            @for (county of state.counties; track county) {
              <ul class="county-list">
                <li class="list-position">{{ county.county_name }}</li>
              </ul>
            }
          </div>
        }
      </div>
    }
  </div>

  @if (data.type != 'pick-role') {
    <div mat-dialog-actions align="end">
      @if (data?.type != 'ok') {
        <button mat-flat-button class="lap-warn" (click)="yesDelete()">Yes</button>
      }
      @if (data?.confirm=='yes') {
        <button mat-flat-button mat-dialog-close>Confirm</button>
      } @else {
        <button mat-raised-button mat-dialog-close>{{data?.type != 'ok' ? 'No' : 'Ok'}}</button>
      }
    </div>
  }
  @if (data.type == 'pick-role') {
    <div mat-dialog-actions align="end">
      <button mat-flat-button mat-dialog-close class="lap-warn">Ok</button>
      <button mat-raised-button mat-dialog-close>Cancel</button>
    </div>
  }
</div>
